import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";
import { DiaprofilPatient } from "../../app/models/diaprofil-patient";
import { DiaprofilProTask } from "../../app/models/diaprofil-pro-task";
import { WidgetConfig } from "@zitelab/ionic-fhir-questionnaires/dist/models/widget";
import {
  QuestionnaireService,
  QuestionnaireState,
  QuestionnaireResponseService,
  AnswerInfo
} from "@zitelab/ionic-fhir-questionnaires";
import { FhirService } from "../../app/services/fhir.service";
import { KRAM_QUESTIONNAIRE_UUID } from "../../app/models/types";
import { diaprofilEnableWhenFunctions } from "../../app/utils/enable-when-functions";
import { DashboardService } from "../../app/services/dashboard.service";
import { TranslateService } from "@ngx-translate/core";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
import { _i18n_str } from "../../assets/i18n/non-static-ids";
import * as moment from "moment";
import { map } from "rxjs/operators";

@Component({
  selector: "kram-modal",
  templateUrl: "kram.modal.html"
})
export class KramModal {
  patient: DiaprofilPatient;
  proTask: DiaprofilProTask;
  loading = true;
  widgets: WidgetConfig<any>[] = [];
  flattenedAnswers: {};
  widgetsWithAnswers: { widget: WidgetConfig<any>; answer: AnswerInfo }[] = [];
  questionnaireResource: fhir.Questionnaire;
  state: QuestionnaireState | undefined;
  responseExtensions: { url: string; [key: string]: any }[];
  private enableWhenFunctions: {
    [key: string]: (formAnswers: { [key: string]: any }) => boolean;
  } = diaprofilEnableWhenFunctions;
  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public translate: TranslateService,
    public questionnaireService: QuestionnaireService,
    public dashboard: DashboardService,
    public fhir: FhirService,
    public toastCtrl: ToastController,
    public questionnaireResponseService: QuestionnaireResponseService
  ) {
    this.patient = (navParams.get("patient") || {}) as DiaprofilPatient;
    this.proTask = (navParams.get("proTask") || null) as DiaprofilProTask;
    this.getKramResponse(this.proTask.response).subscribe(result =>
      console.log(result)
    );
  }

  getKramResponse(associatedResponse: fhir.QuestionnaireResponse) {
    const minDate = moment(associatedResponse.authored).format("YYYY-MM-DD");
    const maxDate = moment(associatedResponse.authored)
      .add(1, "day")
      .format("YYYY-MM-DD");
    const questionnaire = this.fhir.resolveReference(
      `Questionnaire/${KRAM_QUESTIONNAIRE_UUID}`
    ) as fhir.Questionnaire;
    return this.fhir
      .getQuery({
        resourceType: "QuestionnaireResponse",
        queryString: [
          `author=${associatedResponse.author.reference}`,
          `questionnaire=Questionnaire/${KRAM_QUESTIONNAIRE_UUID}`,
          `authored=ge${minDate}&authored=le${maxDate}`,
          "_sort=-authored",
          "_count=1"
        ].join("&")
      })
      .pipe(
        map(bundle => {
          if (bundle.total >= 1) {
            const responseResource = bundle.entry[0]
              .resource as fhir.QuestionnaireResponse;
            const items = this.questionnaireResponseService.extractAnswersFromQuestionnaireResponse(
              responseResource
            );
            console.log(items);
            this.flattenedAnswers = this.questionnaireResponseService.flattenQuestionnaireAnswers(
              items
            );
            console.log(this.flattenedAnswers);
            this.widgets = this.dashboard.findWidgetsForResponse(
              questionnaire,
              this.flattenedAnswers,
              this.proTask.task.id
            );
            this.widgetsWithAnswers = this.widgets
              .map(widget => ({
                widget,
                answer: this.questionnaireResponseService.getItemAnswerInfo(
                  widget,
                  this.flattenedAnswers
                )
              }))
              .filter(
                item => item.widget.name !== "questionnnaireIntroduction"
              );
            this.loading = false;
            console.log(this.widgetsWithAnswers);
          } else {
            this.widgets = null;
            this.loading = false;
          }
        })
      );
  }

  dismiss($event) {
    this.viewCtrl.dismiss();
  }

  handleFormChange(form) {
    console.log("handleFormChange");
  }

  handleFormSubmit(event, form) {
    this.viewCtrl.dismiss();
  }

  toPreviousPage(event) {}
}



// WEBPACK FOOTER //
// ./src/modals/kram.modal/kram.modal.ts